import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import styled from 'styled-components'
import colors from '../../styles/colors'
import { applyTextStyle } from '../../styles/typography'
import PageTitle from '../PageTitle'

interface IProps {
  className?: string
  image: any
  title: any
  description: string
  alt?: string
  firstPublicationDate?: string
  lang?: string
}

const PostImageCard: React.FC<IProps> = ({
  className,
  image,
  title,
  description,
  alt,
  firstPublicationDate,
  lang,
}) => (
  <Wrapper className={className}>
    <StyledGatsbyImage
      image={image}
      alt={alt ?? 'Card'}
      objectFit="cover"
    ></StyledGatsbyImage>
    <Title field={title}></Title>
    <Description>{description}</Description>
    {firstPublicationDate ? (
      <SubDescription>{formatDate(lang, firstPublicationDate)}</SubDescription>
    ) : null}
  </Wrapper>
)

function formatDate(lang, dateString) {
  if (lang == 'en-gb') {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  } else {
    return new Date(dateString).toLocaleDateString('nl-NL', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }
}

const Wrapper = styled.div`
  width: 100%;
  & img {
    transition: all 0.2s ease-in-out !important;
  }
  &:hover {
    & img {
      transform: scale(1.1);
    }
  }
`

const StyledGatsbyImage = styled(GatsbyImage)`
  max-height: 300px;
`

const Title = styled(PageTitle)`
  ${applyTextStyle('titleSubtle')};
  color: ${colors.grey};
  margin-top: 40px;
  margin-bottom: 16px;
`

const Description = styled.div`
  ${applyTextStyle('normal')};
  color: ${colors.grey};
  margin-bottom: 16px;
`

const SubDescription = styled.div`
  ${applyTextStyle('subtle')};
  color: ${colors.grey};
  opacity: 0.8;
`

export default PostImageCard
